<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4><router-link to="/config/security">{{ $t('Security') }}</router-link> / {{ $t('Connected devices') }}</h4>
        </div>
        <button class="back">
          <i class="fas fa-array-left" />
        </button>
      </div>
    </div>

    <div class="vflex-row-1">
      
      <Paginaty
        :total="paginate.total"
        :pages="paginate.pages"
        :page="paginate.page"
        :creating="creating"
        :loading="loading"
        @changePage="loadData">
        
        <template slot="content">
          <table class="table">
            <thead>
              <tr>
                <th>{{ $t('Device') }}</th>
                <th>{{ $t('IP') }}</th>
                <th>{{ $t('Last acess') }}</th>
                <th>{{ $t('Expires in') }}</th>
                <th>{{ $t('Generated in') }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <SessionItem
                v-for="(item, index) in sessions"
                :key="index"
                :value="item"
                @removed="loadData" />
            </tbody>
          </table>
        </template>

        <template slot="noresults">
          {{ $t('There are no items') }}
        </template>

      </Paginaty>

    </div>
    
  </div>

</template>

<script>
import Paginaty from '@/components/Paginaty/Paginaty'
import SessionItem from './SessionItem'

export default {
  name: 'Source',
  components: {
    Paginaty,
    SessionItem
  },
  data () {
    return {
      creating: true,
      loading: true,
      filters: {},
      sort: '-created_at'
    }
  },
  computed: {
    sessions () {
      return this.$store.getters.getSessions
    },
    paginate () {
      return this.$store.getters.getSessionsPaginate
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData (page) {
      this.loading = true

      const params = {
        ...this.filters,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectSessions', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      })
    },
    setSort (sort) {
      this.sort = sort
      this.loadData(1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Session/Session.vue